import React from "react";
import Block from "ComponentsUI/Block";
import Container from "reactstrap/lib/Container";
import { PlansList } from "ComponentsUI/Plans";
import { inject, observer } from "mobx-react";

@inject("ApplicationModel")
@observer
class TariffsStub extends React.Component {
	render() {
		let {
			ApplicationModel: { windowSizeModel },
		} = this.props;

		if (this.props.withoutBlock) {
			return (
				<React.Fragment>
					<Container>
						<PlansList windowSizes={windowSizeModel.windowSizes} stub={true} />
					</Container>
					<Container>
						<PlansList windowSizes={windowSizeModel.windowSizes} stub={true} />
					</Container>
				</React.Fragment>
			);
		}

		return null;

		return (
			<React.Fragment>
				<Block header={"empty"} stub={true}>
					<Container>
						<PlansList windowSizes={windowSizeModel.windowSizes} stub={true} />
					</Container>
				</Block>
				<Block header={"empty"} stub={true}>
					<Container>
						<PlansList windowSizes={windowSizeModel.windowSizes} stub={true} />
					</Container>
				</Block>
			</React.Fragment>
		);
	}
}

export default TariffsStub;
